// src/firebase/returns/getAllReturnedItems.ts
import { ref, get } from "firebase/database";
import { db } from "../firebaseConfig";
import { ReturnItemData } from "../../models/credit";

export const getAllReturnedItems = async (): Promise<{
	[invoiceNumber: string]: ReturnItemData[];
}> => {
	const returnsRef = ref(db, "returns");
	const snapshot = await get(returnsRef);
	const allReturnedItems: { [invoiceNumber: string]: ReturnItemData[] } = {};
	if (snapshot.exists()) {
		snapshot.forEach((returnedItem) => {
			const returnItem = returnedItem.val() as ReturnItemData;
			if (!allReturnedItems[returnItem.invoiceNumber]) {
				allReturnedItems[returnItem.invoiceNumber] = [];
			}
			allReturnedItems[returnItem.invoiceNumber].push(returnItem);
		});
	}
	return allReturnedItems;
};
